import React from 'react';
import Shimmer from '../../common/Shimmer';

const VideoAdShimmer: React.FC = () => {
  return (
    <div className="video-ad-container shimmer-card">
      <div className="video-ad-content">
        <div className="video-ad-left">
          <Shimmer 
            width="200px" 
            height="120px" 
            borderRadius="8px"
            className="shimmer-image"
          />
        </div>
        
        <div className="video-ad-right">
          <Shimmer width="80%" height="24px" className="shimmer-title" />
          <Shimmer width="60%" height="18px" className="shimmer-subtitle" />
          <Shimmer width="120px" height="40px" className="shimmer-button" />
        </div>
      </div>
    </div>
  );
};

export default VideoAdShimmer;
